module.exports = __webpack_public_path__ + "img/area-9-1.ed26d7a.jpg";